const initialState = {
  bsccods: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "BSC_COD":
      return {
        ...state,
        bsccods: action.payload,
      };
    default:
      return state;
  }
}
